import { ACTIONS } from './actions';

export const getActions = (params) => ({
  client: 'api',
  request: { method: 'get', url: '/actions', params },
  type: ACTIONS,
});
